import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UserInfo } from '@/types/auth';

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: UserInfo | null;
  isAuthenticated: boolean;

  setTokens: (accessToken: string, refreshToken: string, user: UserInfo) => void;
  setUser: (user: UserInfo) => void;
  clear: () => void;
}

/**
 * Store de auth persistido en localStorage.
 *
 * Los tokens se guardan en localStorage para sobrevivir refreshes de pagina.
 * En produccion considerar httpOnly cookies si la seguridad es critica
 * (XSS pueden leer localStorage), pero para una app interna B2B esto es estandar.
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      isAuthenticated: false,

      setTokens: (accessToken, refreshToken, user) =>
        set({
          accessToken,
          refreshToken,
          user,
          isAuthenticated: true,
        }),

      setUser: (user) => set({ user }),

      clear: () =>
        set({
          accessToken: null,
          refreshToken: null,
          user: null,
          isAuthenticated: false,
        }),
    }),
    {
      name: 'mdm-auth',
      // Solo persistir lo esencial
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
    },
  ),
);
